import { render, staticRenderFns } from "./viewRawMaterial.vue?vue&type=template&id=671ebdff&scoped=true&"
import script from "./viewRawMaterial.vue?vue&type=script&lang=js&"
export * from "./viewRawMaterial.vue?vue&type=script&lang=js&"
import style0 from "./viewRawMaterial.vue?vue&type=style&index=0&id=671ebdff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671ebdff",
  null
  
)

export default component.exports